import { z } from "zod"

const pairRewardItem = z.object({
  rewardAmount: z.number(),
  rewardAmountRaw: z.string(),
})

export const pairRewardResponseSchema = z.record(z.string(), pairRewardItem)

export type PairRewardResponse = z.infer<typeof pairRewardResponseSchema>
export type PairRewardResponseItem = PairRewardResponse[number]
